//import MainContent2 from "../MainContent2";
import MainContentH from "../MainContentH";
import AsideContent2 from "../AsideContent2";
import LockeJohn from "../assets/resources/LockeJohn";

const HomePage = () => {
    return (
        <div className="content">
            <main>
                <MainContentH resource={LockeJohn}/>
            </main>
            <aside>
                <AsideContent2 resource={LockeJohn}/>
            </aside>
    	
  	    </div>
    );
}

export default HomePage;